import * as yup from 'yup';

export const overviewSchema = yup.object({
    startDate: yup.string().label('startDate').required('Este campo es requerido'),
    endDate: yup.string().label('endDate').required('Este campo es requerido'),
});

export type overviewSchemaType = yup.InferType<typeof overviewSchema>
